<template>
  <div class="m-content">
    <SelectQuality v-for="(item,index) in categoryArray" :content="item" v-on:listenToChildEvent="getAnswer"></SelectQuality>
    <SelectQualityOption v-for="(item,index) in categoryArray" :content="item" v-on:listenToChildEvent="getAnswer"></SelectQualityOption>
    <div class="btn-group">
      <button class="default-btn large-btn" :class="show?'half-opacity':''" v-if="showButton" @click="showNext">下一步</button>
      <button class="default-btn large-btn submit-btn" v-if="submit" @click="submitData" v-preventReClick>提交</button>
    </div>
  </div>
</template>
<script>
  import SelectQuality from '../components/SelectQuality'
  import SelectQualityOption from '../components/SelectQualityOption'
  import axios from 'axios'
  import qs from 'qs'
  import { mapState } from 'vuex'
  
  export default {
    props: {
      id: Number
    },
    name: 'Quality',
    components: {
      'SelectQuality':SelectQuality,
      'SelectQualityOption':SelectQualityOption
    },
    data() {
      return {
        categoryArray:[
          {'num':1,'title':'','type':8,'show':true,'option1':[{'name':'成就导向','number':12},{'name':'主动性','number':14},{'name':'问题解决','number':6},{'name':'坚韧性','number':8},{'name':'重视次序、品质与精确','number':13}],
          'option2':[{'name':'人际理解','number':15},{'name':'服务精神','number':16}],
          'option3':[{'name':'影响力','number':17},{'name':'关系建立','number':18},{'name':'沟通协调','number':3},{'name':'语言表达','number':11}],
          'option4':[{'name':'培养他人','number':19},{'name':'命令与果断','number':20},{'name':'团队合作','number':5},{'name':'领导能力','number':21}],
          'option5':[{'name':'分析式思考','number':22},{'name':'概念（归纳）式思考','number':23},{'name':'信息收集与分析','number':10},{'name':'学习发展','number':2},{'name':'创新','number':7},{'name':'分析判断','number':9},{'name':'专业知识','number':24}],
          'option6':[{'name':'自我控制','number':4},{'name':'自信心','number':25},{'name':'弹性','number':26},{'name':'责任心','number':27}]
          },
          {
            'num':2,'show':false,'title':'学习发展','type':9,'options':[
              {'num':1,'order':'1.','title':'学习一个新知识、新技能之前，我会提前查阅资料，做好充分的预习准备，以便自己能够掌握新知识、新技能。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'我经常总结自己成功和失败的经验，以寻找提高自己能力的途径。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'我善于分析自己目前知识和技能结构与目标要求之间的差距，并快速采取行动来弥补。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'遇到学习困难时，我通过发动身边的资源（比如网络学习、询问老师和同学等）来帮助自己解答了疑惑。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':5,'order':'5.','title':'我已经将大学的学习目标与自己的职业规划相结合，并制定了相应的学习计划。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':6,'order':'6.','title':'我通过查阅资料、实践、向他人请教等多种方式帮助自己弥补了所缺的知识和技能。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ]
          },
          {
            'num':3,'show':false,'title':'沟通协调','type':9,'options':[
              {'num':1,'order':'1.','title':'遇到沟通障碍时，我经常不断地和他人进行交流讨论，直到澄清问题为止，不会刻意回避。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'如果和同学在沟通某件事的过程中无法达成共识，我会站在他们的角度和立场去考虑问题。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'我善于倾听各方的意见，并及时调整和回应。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'为了实现某个目标，我积极主动的与相关人员进行了多次沟通和确认。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':5,'order':'5.','title':'为了获得良好的沟通效果，我经常提前模拟和推演沟通的过程和可能的场景，做好充分准备。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
            ],
          },
          {
            'num':4,'show':false,'title':'自我控制','type':9,'options':[
              {'num':1,'order':'1.','title':'我经常反省和审视自己，发现自己的优缺点并给予正确评价。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'在压力面前，我采取深呼吸、运动等多种途径让自己保持冷静，控制住了自己的负面情绪。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'在过去完成某个任务的过程中，我通过制定工作计划和时间表的方式帮助自己排除了干扰，从而让自己将主要的精力放在了最重要的任务上。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'我善于寻找学习中的意义，这样的话即使是遇到学习挫折或困难，我都能够保持较高的学习热情。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},

            ],
          },
          {
            'num':5,'show':false,'title':'团队合作','type':9,'options':[
              {'num':1,'order':'1.','title':'我通过良好的言行和形象赢得了他人的信任和尊重。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'与他人合作完成某个任务时，我在不断的和他人进行沟通的过程中澄清了自己和他人的想法并取得一致。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'我经常会向团队中的成员请教一些问题，听取他们的看法和意见。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'在团队中，我在较短的时间里就找到了自己对团队的价值与贡献，并履行了自己应尽的责任。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':5,'order':'5.','title':'如果由我来策划一场班级活动，我会先组织几个同学成立一个团队，以团队合作的方式来完成这个任务。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':6,'order':'6.','title':'在团队中，我不断的调整自己的行为以适应整个团队的发展，目的就是配合大家朝着团队目标而努力。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':7,'order':'7.','title':'团队出现矛盾时，我通常在第一时间就和大家沟通，从中协调，尽力解决矛盾，从而维护团队在外人眼中的形象。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':6,'show':false,'title':'问题解决','type':9,'options':[
              {'num':1,'order':'1.','title':'我善于从问题的各种表象中去挖掘问题产生的根源，从而找到真正的原因。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'当问题发生时，我尽可能地征求身边人的意见和方案来协助我解决。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'在问题解决过程中，我通常会准备多种方案，然后在权衡每个方案利弊的基础上选出最佳方案。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'当面临的问题需要做出各种取舍时，我能够快速做出合适的决定，不会犹犹豫豫。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':5,'order':'5.','title':'每解决一个问题，我都会从中总结经验，来提高自己问题解决的能力。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':6,'order':'6.','title':'即使发生突发事件也不会打乱我现有的节奏，我能迅速反应，采取行动来面对。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':7,'show':false,'title':'创新','type':9,'options':[
              {'num':1,'order':'1.','title':'当新事物、新信息出现时，我通常会通过各种方式去加以了解。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'我不受陈规和老旧经验的束缚，而是不断改进学习方法以适应形势发展的要求。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'我会尝试运用一些新的方法来解决问题，即使会承担风险。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'在解决问题的过程中，我尝试了各种新的方法和思路，而不是一味的依靠自己的经验和惯性。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':5,'order':'5.','title':'我经常鼓励身边的人能够提出一些新的观点和方法。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':8,'show':false,'title':'坚韧性','type':9,'options':[
              {'num':1,'order':'1.','title':'面对既定的目标，我能够坚持推进，使自己不断朝向目标努力。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'我能够在坚持目标的基础上灵活的处理面临的困难。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'我经常根据目标发展的阶段来采取不同的行动策略，一步步的去实现目标。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'即使在实现目标的过程中会遇到各种阻力和困难，我也会坚持下去，不会半途而废。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':9,'show':false,'title':'分析判断','type':9,'options':[
              {'num':1,'order':'1.','title':'无法实现既定目标时，我能根据现有的信息和自己以往的经验与认知找到真正原因。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'我能够对网上呈现出来的大量信息进行判断，知道哪些是真实的，哪些是虚构的。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'我善于经过分析、理解、判断、综合等一系列思考过程再对事情作出推断。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'我经常在整合加工零散信息的基础上，对多种解决方案进行了利弊权衡，从而选出最佳的方案。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':10,'show':false,'title':'信息收集与分析','type':9,'options':[
              {'num':1,'order':'1.','title':'通过网络、报纸杂志书籍、会议和人际交流等多种途径，我获得了大量信息。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'收集信息后，我对信息进行了分类、整理和贮存，以便在必要时可以迅速提取调用。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'我有目的的用自己的语言来将收集到的信息转化成自己的观点。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'我善于对零散信息进行归纳整理，并形成对自己指导作用的意见或建议。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':11,'show':false,'title':'语言表达（口头）','type':9,'options':[
              {'num':1,'order':'1.','title':'与人交流时，我总能快速、清晰的表达自己的观点，而不是支支吾吾。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'向他人传达信息时，我综合运用了言语、肢体以及书面等多种表达方式，确保表达准确。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'跟别人交流时，我使用简洁、精炼的语言让他人快速的理解了我要表达的意思。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'我会根据沟通对象的不同，随机应变地采取不同的表达方式和策略。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':12,'show':false,'title':'成就导向','type':9,'options':[
              {'num':1,'order':'1.','title':'不管接到什么样的任务，我都希望自己能够出色完成。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'任务本身带来的意义是我出色完成的最主要原因。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'为确保计划和目标的达成，我知道怎样把决定付诸行动，并继续向前推进，最终完成计划和目标。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'我敢于挑战，为自己设立了具有挑战性的目标，并努力使其实现。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':13,'show':false,'title':'重视次序、品质与精确','type':9,'options':[
              {'num':1,'order':'1.','title':'在进行某个任务时，我通过对获取到的信息进行反复校对和检查，来不断改进实施步骤，使任务能够高标准完成。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'在开始着手某个学习任务前，我就已经做好了规划，来监控自己的行为和进度，使整个过程能够有序进行。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'我经常持续追踪自己的行为和目标完成情况，以便能发现其中存在的问题，及时进行调整。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'我善于合理安排时间和资源，确保在规定时间内以低投入高质量的顺利完成任务。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':5,'order':'5.','title':'我经常对自己的学习计划进行盘点和反思，不断改进学习策略和方法，提高学习效率。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':14,'show':false,'title':'主动性','type':9,'options':[
              {'num':1,'order':'1.','title':'我经常通过招聘网站、行业快报等途径浏览就业方面的信息，了解与专业相关的就业机会，以便在求职或实习时抓住机会。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'我经常主动承担并付出了额外的心力去完成与团队任务相关的事情，即使没有人对我做出要求。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'问题发生后，在没有人要求解决这个问题之前我就主动地去了解问题，提前做好准备，而不是被动的等待事情发展再采取行动。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':15,'show':false,'title':'人际理解','type':9,'options':[
              {'num':1,'order':'1.','title':'从他人的面部神情和动作中我就可以感知到他们的情绪如何。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'通过倾听和观察我可以识别出他人遇到的问题是什么，并采取行动提供协助。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'通过别人的话语和行为我可以了解到他们的态度或观点。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':16,'show':false,'title':'服务精神','type':9,'options':[
              {'num':1,'order':'1.','title':'从别人的言语或行为中我就能快速了解到他人的需要。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'我乐于为他人提供对他们有用的信息。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'一旦答应了别人要做某件事，我都会负责到底，帮他把事情做好。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'我把自己的联系方式给了身边的朋友，以便他们需要帮助时能够找到我。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':17,'show':false,'title':'影响力','type':9,'options':[
              {'num':1,'order':'1.','title':'我通过劝说、说服等多种方式影响过他人的思想、情感或行为。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'我主动积极的采取过各种行动来获得了他人对我的支持。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'在讨论某个课题上，如果有同学不同意我的观点，我会在现场寻求老师或其他人的帮助，让他们帮助我进行说服。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'当别人不同意我的意见时，我通过调整自己的陈述方式和讨论内容，来适应他人的兴趣与习惯，从而获得了支持。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':18,'show':false,'title':'关系建立','type':9,'options':[
              {'num':1,'order':'1.','title':'在课余之外，我经常和他人就学习相关的问题展开了讨论。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'我从身边的朋友那里获得了很多有用的学习资源或机会。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'我通过友善的与人相处，以主动、热情和真诚的态度和同学们建立起了融洽的关系。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'我经常参加郊游、聚会、晚会等活动，从中交到了一些新朋友，扩大了自己的朋友圈。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':5,'order':'5.','title':'我经常和身边的同学分享自己最新了解到的资讯，和大家充分讨论，促进自己对资讯的全面了解。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':19,'show':false,'title':'培养他人','type':9,'options':[
              {'num':1,'order':'1.','title':'我对身边他人的成长和进步表达了肯定和鼓励。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'我经常和别人分享我的一些有用的学习经验。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'我经常积极的引导身边的人去实现他们定下的学习目标。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'我经常有意识的向他人推荐学习资源或机会，以促进他们的专业成长。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':5,'order':'5.','title':'当有人询问我专业学习上的问题时，我都为他人提供了意见和反馈。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':20,'show':false,'title':'命令：果断','type':9,'options':[
              {'num':1,'order':'1.','title':'在征集团队成员的意见过程中，如果有人提出的意见对实现团队目标没有帮助，我会毫不犹豫的舍弃。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'如果以小组的形式完成课程作业，我都会给每个组员分配好任务。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'为了达成团队目标，我会要求每个团队成员必须按照我制定的标准来执行。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':21,'show':false,'title':'领导能力','type':9,'options':[
              {'num':1,'order':'1.','title':'安排会议时，我能做好会议流程、目标、时间控制、任务分配等工作。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'我经常和他人分享自己所掌握的信息和资讯来帮助其获得成长，开拓视野。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'我采取了相关的行动策略来提高整个团队的办事效率和士气。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'在团队中，我经常会有意识的注意自己的一言一行，以身作则，给其他人做好带头示范。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':5,'order':'5.','title':'在团队中，我通过提出有影响力的想法来获得了他人的信任和支持。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':6,'order':'6.','title':'通过我建立起来的团队成员行为规范守则，让我带领的团队能够有序的开展活动。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':22,'show':false,'title':'分析式思考','type':9,'options':[
              {'num':1,'order':'1.','title':'当面临一项复杂的任务时，我就把它们拆分成了一系列简单的小任务或活动。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'面临多个任务时，我经常根据任务的轻重缓急来决定要完成的优先顺序。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'我能从多个角度来分析问题发生的原因，并找到原因之间之间的关联之处。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'问题发生后，我根据问题的症状判断出可能会造成的后果或影响，并提前考虑好了应对步骤。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':23,'show':false,'title':'概念（归纳）式思考','type':9,'options':[
              {'num':1,'order':'1.','title':'我能根据自己所了解到的常识和自己过去的经验来确定问题所在。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'当目前的情况和过去的情况类似时，我能够辨认出它们之间的相似性。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'我运用自己所学到的理论知识和过去的经验了解到了当前的局势。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'我能够把复杂的观点或情况用清晰、简单或易于理解的方式呈现出来。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':24,'show':false,'title':'专业化','type':9,'options':[
              {'num':1,'order':'1.','title':'我能够运用所学到的知识对某个现象进行解释。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'我对本专业领域的趋势、前景和历史发展等有敏锐的嗅觉。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'我对自己的专业能力有充分的信心，面对挑战时，相信自己的判断和决定。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'如果在团队合作中涉及到不同专业的同学时，我愿意去了解其他专业同学的知识技能，以便能够更好的配合实现合作。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':25,'show':false,'title':'自信心','type':9,'options':[
              {'num':1,'order':'1.','title':'遇到沟通障碍时','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'如果和同学在沟','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'我善于倾听各','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'为了实现某','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':26,'show':false,'title':'弹性与适应','type':9,'options':[
              {'num':1,'order':'1.','title':'面对高中和大学学习的不同，我已经找到了适合自己的学习方法。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'我和班级中来自不同地区的同学相处得很愉快。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'我能够根据不同地域、不同文化背景的同学来调整自己的沟通策略。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'和他人意见不一致时，我采取了妥协、让步等策略来化解争论。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':5,'order':'5.','title':'即使面临超负荷的学习压力，我也毫不畏惧，仍然可以调动自己的情绪保持战斗力。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          },
          {
            'num':27,'show':false,'title':'责任心','type':9,'options':[
              {'num':1,'order':'1.','title':'我对自己的学习内容和学习任务有深刻的认识，知道当下的学习对自己实现目标的重要性。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':2,'order':'2.','title':'我经常对自己和身边他人在学习中存在的问题进行思考，并及时指正。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':3,'order':'3.','title':'即使完成某个团队任务需要占用个人时间，我也会毫不犹豫的把团队任务放在首位。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':4,'order':'4.','title':'只要是我需要做的事情，我会投入大量的时间和精力把它做好。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''},
              {'num':5,'order':'5.','title':'只要是我负责的事情，无论如何都会负责到底，不会中途随便转交给别人。','type':3,'show':true,fixArr: ['非常不符合', '', '', '', '', '非常符合'],errorMessage:''}
            ],
          }
        ],
        show:true,
        showButton:true,
        submit:false,
        answers:[],
        next:-1
      }
    },
    computed: {
      ...mapState({
        shengyaUser: state => state.shengyaUser.userInfo,
      }),
    },    
    methods:{
      // 从子组件获取答案
      getAnswer(text,num){
        if(num==1&&typeof(text)=="object"){
          this.answers = text
          this.show=false
        }else{
          this.answers[this.next].answer[num-1] = text
          let count=0
          this.answers[this.next].answer.map((item,index)=>{
            if(item){
              count++
            }
          })
          if(count==this.answers[this.next].answer.length){
            this.show=false
          }
        }
      },
      // 显示下一步
      showNext(){
        if(!this.show&&this.answers.length>0){
          this.next++
          let num = this.answers[this.next].number
          this.categoryArray.map((item,index)=>{
            if(item.show){
              this.categoryArray[index].show=false
            }
            if(item.num==num){
              this.categoryArray[index].show=true
              this.show =true
              let length = this.categoryArray[index].options.length
              this.answers[this.next].answer=Array(length)
            }
          })
          if(this.next == this.answers.length-1){
            this.showButton = false
            this.submit =true
          }
        }
      },
      // 提交数据
      submitData(){
        if(!this.show){
          let result = ''
          this.answers.map((item,index)=>{
            result+=(index+1)+"$0<"+item.name+","
            item.answer.map((pep,zindex)=>{
               result+=(zindex+1)+"<"+pep
               if(zindex<item.answer.length-1){
                 result+=","
               }
            })
            if(index<this.answers.length-1){
              result+="}"
            }
          })
          const options = {
            method: 'POST',
            headers: {
              'content-type': 'application/x-www-form-urlencoded'
            },
            data: qs.stringify({
              submitdata:result,
              openId: this.shengyaUser.openid
            }),
            url: '/cob/saveTreaAbilityAnswer.do'
          };
          axios(options)
            .then((response)=>{
              if(response.data.result.success){
                let cddqAnswer = response.data
                let shengyaUser = cddqAnswer.data.user
                this.$bus.$emit('play-finish', shengyaUser)
                this.$emit("listenToChildEvent")
              }else{
                this.$store.commit('showMessage', {
                  message: response.data.result.message,
                  type: 'error'
                })
              }
            })
            .catch((error)=>{
              console.log(error);
            });
        }

      }
    }
  }
</script>
<style lang="stylus" scoped>

</style>
